export default __webpack_public_path__ + "static/bg_preg.jpg?f9f6c66774fa";